import { forwardRef, memo } from 'react';
import styled from 'styled-components';
import { ColorSchemeCSSVariable } from '../use-color-scheme';
import type { WheelRewardType } from '../use-wheel-rewards';
import { turnToRad } from '../utils';
import { Sector } from './sector';

export interface DiskProps {
  radius: number;
  rewards: WheelRewardType[];
}

export const Disk = memo(
  forwardRef<HTMLDivElement, DiskProps>(function Disk(
    { radius, rewards }: DiskProps,
    ref
  ) {
    const diameter = 2 * radius;
    const sectorFraction = 1 / rewards.length;

    return (
      <Backing
        ref={ref}
        style={{
          width: diameter,
          height: diameter
        }}
      >
        {rewards.map(({ id, label, backgroundColor }, index) => {
          return (
            <Sector
              key={id}
              radius={radius}
              fraction={sectorFraction}
              angle={turnToRad(index * sectorFraction)}
              label={label}
              customBackgroundColor={backgroundColor ?? undefined}
            />
          );
        })}
      </Backing>
    );
  })
);

const Backing = styled.div`
  overflow: hidden;
  border-radius: 50%;
  position: relative;
  background: var(${ColorSchemeCSSVariable.DiskBackground});
`;
